import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const StaffCheckHistoryNote = (function() {
  function GetPagedStaffNotes(monitoredIndividualId, unitId, numberToSkip, numberToTake, order, searchTerms) {
    if (logComponent('StaffCheckHistoryNote')) { console.debug('StaffCheckHistoryNote GetPagedStaffNotes'); }
    const params = { numberToSkip, numberToTake, order, searchTerms };
    if (monitoredIndividualId) params.monitoredIndividualId = monitoredIndividualId;
    if (unitId) params.unitId = unitId;

    return axios.get('api/StaffCheckHistoryNote/GetPagedStaffNotes', getConfig( params));
  } 
  
  function GetPagedFamilyNotes(monitoredIndividualId, unitId, numberToSkip, numberToTake, order, searchTerms) {
    if (logComponent('StaffCheckHistoryNote')) { console.debug('StaffCheckHistoryNote GetPagedFamilyNotes'); }
    const params = { numberToSkip, numberToTake, order, searchTerms };
    if (monitoredIndividualId) params.monitoredIndividualId = monitoredIndividualId;
    if (unitId) params.unitId = unitId;

    return axios.get('api/StaffCheckHistoryNote/GetPagedFamilyNotes', getConfig( params));
  }

  function GetPagedNotes(monitoredIndividualId, unitId, numberToSkip, numberToTake, order, searchTerms) {
    if (logComponent('StaffCheckHistoryNote')) { console.debug('StaffCheckHistoryNote GetPagedNotes'); }
    const params = { numberToSkip, numberToTake, order, searchTerms };
    if (monitoredIndividualId) params.monitoredIndividualId = monitoredIndividualId;
    if (unitId) params.unitId = unitId;

    return axios.get('api/StaffCheckHistoryNote/GetPagedNotes', getConfig( params));
  }

  return {
    GetPagedStaffNotes,
    GetPagedFamilyNotes,
    GetPagedNotes
  }
})();

export default StaffCheckHistoryNote;